import React, { useMemo } from 'react'
import { MedicationKnowledge } from '@teschglobal/tg-fhir-react-components'
import type { MedicationKnowledge as FHIRMedicationKnowledge, CombinedMedicationKnowledge } from '@teschglobal/tg-fhir-react-components/dist/types'
import { buildExtSlices } from '../../../../../utils/helpers'

type MedicationKnowledgeDetailProps = {
  resource?: FHIRMedicationKnowledge | CombinedMedicationKnowledge | null
}

const formatResourceWithSlices = (resource: FHIRMedicationKnowledge) => {
  const extSlices = buildExtSlices(resource.extension as any, 'MedicationKnowledge')
  return { ...resource, ...extSlices } as CombinedMedicationKnowledge
}

const MedicationKnowledgeDetail: React.FC<MedicationKnowledgeDetailProps> = ({ resource }) => {

  const formattedResource = useMemo(() => {
    if (!resource) return null
    return formatResourceWithSlices(resource)
  }, [resource])
  
  if (!formattedResource) {
      return (
          <div className="text-center" role="status" aria-live="polite" aria-atomic="true">
              Not Found
          </div>
      )
  }

  return (
    <section>
      <h3>MedicationKnowledge</h3>
      <MedicationKnowledge
        data={formattedResource}
      />
    </section>
  )
}

export default MedicationKnowledgeDetail